module.exports = __webpack_public_path__ + "static/media/orangeFlower.d0678705.png";